export function digitsIn(value: string): number {
  return value.replace(/\D/g, '').length;
}

// helpers/api throws the server's `errors` array, or the raw axios error when the response carried
// none - so a message is only available in the first case.
export function messageFor(thrown: unknown): string {
  if (Array.isArray(thrown) && thrown.length > 0) {
    return String(thrown[0]);
  }

  return 'Something went wrong. Try again in a moment.';
}
